import { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import gql from "graphql-tag"
import { useMutation } from "@apollo/react-hooks"
import { Button, Input, WarnMesssage, Stack } from "@collegebacker/backer-ui/ui"

import { emailValue } from "modules/auth/LocalState"
import { buildPath } from "routes"

import {
  activationDateValue,
  amountValue,
  firstDayValue,
  frequencyValue
} from 'modules/contribution/LocalState'
import { startContributionUrl } from "modules/contribution/helpers"

import styles from './GiftingReturningGuest.module.scss'
import { graphQLErrorMessage } from "utils/validation"

const RESET_PASSWORD = gql`
  mutation ResetPassword(
    $email: String!,
    $redirectTo: String,
    $origin: String
    $amount: Int
    $firstDay: Int
    $frequency: String
    $activationDate: String
  ) {
    resetPassword(
      email: $email,
      redirectTo: $redirectTo,
      origin: $origin
      amount: $amount
      firstDay: $firstDay
      frequency: $frequency
      activationDate: $activationDate
  ) {
      success
    }
  }
`

const GiftingReturningGuest = ({
  fund,
  redirectToContributionFirstStepIfReload
}: Props) => {
  const history = useHistory()
  const email = emailValue()
  const [emailSent, setEmailSent] = useState(false)
  const [resetPasswordError, setResetPasswordError] = useState()
  const [resetPassword, { loading }] = useMutation(RESET_PASSWORD)

  useEffect(() => {
    if (redirectToContributionFirstStepIfReload) redirectToContributionFirstStepIfReload()
  }, [])

  return (
    <section className={styles.container}>
      <Stack spacing={30} className={styles.wrap}>
        {emailSent && (setTimeout(() => setEmailSent(false), 10000)) && (
          <WarnMesssage
            type="success"
            text={"We've emailed you! Please check your inbox for instructions on how to set up your password."}
            className={styles.warnMessage}
          />
        )}
        <WarnMesssage text={graphQLErrorMessage(resetPasswordError)} type="error" />
        <Stack spacing={20}>
          <h1 className="typo-app-title-medium-adaptive">We've met before!</h1>
          <p className="app-body-paragraph">That email address has been used previously to give gifts. Please use the link below to receive a secure link so you can track past gifts and manage future ones.</p>
        </Stack>
        <Input
          className={styles.input}
          label="Email"
          name="email"
          helperText="This field is disabled"
          value={email}
          disabled={true}
        />
        <Stack spacing={15} className={styles.CTAButtons}>
          <Button
            label="Email me a link"
            type="button"
            disabled={loading || emailSent}
            onClick={async () => {
              const search = '?modal=true&step=message'
              try {
                await resetPassword({
                  variables: {
                    email,
                    redirectTo:
                      fund
                        ? encodeURIComponent(`${buildPath('giftingPage', { handle: fund?.handle })}${search}`)
                        : startContributionUrl({
                          flow: 'create-starter-gift',
                          step: 'beneficiary'
                        }),
                    origin: "web",
                    amount: amountValue(),
                    frequency: frequencyValue(),
                    firstDay: firstDayValue(),
                    activationDate: activationDateValue()
                  }
                })
                setEmailSent(true)
              } catch (error: any) {
                setResetPasswordError(error)
              }
            }}
          />
            <Button label="Use another email" mode="ghost" onClick={
              () => {
                history.push(buildPath('loginEmail'))
            }} />
        </Stack>
      </Stack>
    </section>
  )
}
interface Props {
  fund?: {
    handle: string
  }
  redirectToContributionFirstStepIfReload?: () => void
}

export default GiftingReturningGuest
